import { isSsr } from '../lib-ssr';
import { matchMediaFrom } from '../lib-breakpoints';
import { registerResizeListener } from '../lib-resizeListener';
import { throttle } from '../lib-throttle';
function getMockMql(matches) {
    if (matches === void 0) { matches = false; }
    return { addListener: function () { }, removeListener: function () { }, matches: matches };
}
function initMqls() {
    return {
        XS: getMockMql(true),
        S: getMockMql(),
        M: getMockMql(),
        L: getMockMql(),
        XL: getMockMql(),
        XXL: getMockMql(),
    };
}
function registerWindowMediaListener(breakpointCb) {
    breakpointCb = throttle(breakpointCb);
    var mqls = initMqls();
    var disconnect = [];
    var currentBreakpoint = null;
    var findCurrentMatch = function () {
        var getNewBreakpoint = function () {
            var newBreakpoint = 'XS';
            for (var key in mqls) {
                if (mqls[key].matches) {
                    newBreakpoint = key;
                }
                else {
                    break;
                }
            }
            return newBreakpoint;
        };
        var newBreakpoint = getNewBreakpoint();
        if (newBreakpoint !== currentBreakpoint) {
            currentBreakpoint = newBreakpoint;
            breakpointCb(currentBreakpoint);
        }
    };
    var _loop_1 = function (key) {
        if (key !== 'XS') {
            mqls[key] = window.matchMedia(matchMediaFrom(key));
        }
        var cb = function () { return findCurrentMatch(); };
        mqls[key].addListener(cb);
        disconnect.push(function () { return mqls[key].removeListener(cb); });
    };
    for (var key in mqls) {
        _loop_1(key);
    }
    findCurrentMatch();
    return function () {
        disconnect.forEach(function (cb) { return cb(); });
        breakpointCb === null || breakpointCb === void 0 ? void 0 : breakpointCb.cancel();
    };
}
export function getBreakpointSync() {
    var mqls = initMqls();
    var newBreakpoint = 'XS';
    for (var key in mqls) {
        if (key !== 'XS') {
            var breakpointMQ = window.matchMedia(matchMediaFrom(key));
            if (breakpointMQ.matches) {
                newBreakpoint = key;
            }
            else {
                break;
            }
        }
    }
    return newBreakpoint;
}
/**
 * Calls breakpointCb when viewport breakpoint has changed.
 *
 * @param breakpointCb The callback. Note that it gets throttled and
 *                     you have to bind the 'this' context if you need it.
 * @param element Optional element. The optional custom viewport. Default: window.
 */
export function breakpointListener(breakpointCb, element) {
    var disconnect = function () { };
    if (isSsr)
        return disconnect;
    if (element) {
        disconnect = registerResizeListener(element, breakpointCb);
    }
    else {
        disconnect = registerWindowMediaListener(breakpointCb);
    }
    return function () { disconnect(); };
}
